// Renders admin-authored rich-text HTML on public pages with consistent
// brand-styled typography. Falls back to plain text if the value has no markup.
export default function RichText({ html, className = "" }) {
  if (!html) return null;
  const isHtml = /<[a-z][\s\S]*>/i.test(html);
  if (!isHtml) {
    // plain text — preserve line breaks
    return (
      <div className={`whitespace-pre-line ${className}`}>{html}</div>
    );
  }
  return (
    <div
      className={`prose prose-slate max-w-none [&_h2]:font-serif [&_h2]:text-[#0a2540] [&_h3]:font-serif [&_h3]:text-[#0a2540] [&_a]:text-[#023e8a] [&_a]:underline ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
